/**
 * Determines the theme based on time of day.
 * Light: 07:00 – 18:59 (hours 7 through 18)
 * Dark:  19:00 – 06:59 (hours 19 through 23, 0 through 6)
 */
export function getAutoTheme(): 'light' | 'dark' {
    const hour = new Date().getHours();
    return hour >= 7 && hour < 19 ? 'light' : 'dark';
}
